import { Component, inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { AssetHierarchyComponent } from "../../shared/widgets/asset-hierarchy/asset-hierarchy.component";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { NgClass } from "@angular/common";
import { ASSET_TYPES } from "../../enums/assetTypes.enum";

import { HasPermissionDirective } from "../../shared/directives/has-permission/has-permission.directive";
import { PermissionService } from "../../services/api/permission/permission.service";
import { pathToAssetType } from "../../shared/utils/assetType.utils";
import { SimplebarAngularModule } from "simplebar-angular";

@Component({
  standalone: true,
  selector: "app-energy-tool",
  imports: [AssetHierarchyComponent, RouterModule, NgClass, HasPermissionDirective, SimplebarAngularModule],
  templateUrl: "./energy-tool.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./energy-tool.component.scss",
})
export class EnergyToolComponent implements OnInit {
  private router = inject(Router);
  private assetType!: string | null;
  private gridClass = "";

  public permissions = inject(PermissionService);
  public initialSelectedAssetId: string | null;
  public initialSelectedAssetType: string | null;
  private route = inject(ActivatedRoute);

  constructor() {
    const path = this.route.firstChild?.snapshot.routeConfig?.path?.split("/")[0] ?? null;
    this.initialSelectedAssetType = path ? pathToAssetType(path) : null;
    this.initialSelectedAssetId = this.route.firstChild?.snapshot.params["id"] ?? null;
  }

  public ngOnInit() {
    const type = this.router.url.split("/")[3];
    this.assetType = pathToAssetType(type);
  }

  /**
   * Navigate to the energy tool page of the selected asset.
   * @param event Event containing the id and assetType of the asset to navigate to.
   */
  public selectAsset(event: { id: string; assetType: string }) {
    this.assetType = event.assetType;
    let url: string;
    switch (this.assetType) {
      case ASSET_TYPES.TENANT:
        return;
      case ASSET_TYPES.CUSTOMER:
        url = "dashboard/energyTool/customer";
        break;
      case ASSET_TYPES.LOCATION:
        url = "dashboard/energyTool/location";
        break;
      case ASSET_TYPES.BUILDING:
        url = "dashboard/energyTool/building";
        break;
      case ASSET_TYPES.GATE_SYSTEM:
        url = "dashboard/energyTool/gateSystem";
        break;
      default:
        url = "dashboard/energyTool/gateSystem";
        break;
    }

    this.router.navigate([url, event.id]);
  }

  /**
   * Return the CSS class for the grid container based on the current asset type.
   * Used to style the layout of the energy tool components.
   *
   * @returns The CSS class for the grid container.
   */
  public getGridClass() {
    switch (this.assetType) {
      case ASSET_TYPES.TENANT:
        break;
      case ASSET_TYPES.CUSTOMER:
        this.gridClass = "customerGrid";
        break;
      case ASSET_TYPES.LOCATION:
        this.gridClass = "locationGrid";
        break;
      case ASSET_TYPES.BUILDING:
        this.gridClass = "buildingGrid";
        break;
      case ASSET_TYPES.GATE_SYSTEM:
        this.gridClass = "gateSystemGrid";
        break;
      default:
        this.gridClass = "";
        break;
    }

    return {
      [this.gridClass]: true,
    };
  }
}
